@if (waitingForFilterResults) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="list-header">
  <h1 class="page-title">{{ entityTypeName }}</h1>

  <div class="filter-container">
    <mat-button-toggle-group
      (change)="userChangedFilter($event)"
      multiple="true">
      <mat-button-toggle
        value="Owner"
        [checked]="isFilterActive(MyWorkFilter.Owner)">
        I am the Owner
      </mat-button-toggle>
      <mat-button-toggle
        value="ExpiringSoon"
        [checked]="isFilterActive(MyWorkFilter.ExpiringSoon)">
        Expiring Soon (6 months)
      </mat-button-toggle>
      <mat-button-toggle
        value="Expired"
        [checked]="isFilterActive(MyWorkFilter.Expired)">
        Already Expired
      </mat-button-toggle>
      <mat-button-toggle
        value="NextReviewDateSoon"
        [checked]="isFilterActive(MyWorkFilter.NextReviewDateSoon)">
        Next Review Date Soon (6 months)
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <span class="item-count">{{ filteredBaas.length }} BAAs</span>
</div>

<div class="table-container">
  <table mat-table [dataSource]="filteredBaas" matSort (matSortChange)="sortData($event)" class="entity-table">

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let baa" class="status-cell">
        @if (isExpired(baa)) {
          <mat-icon class="status-icon expired" matTooltip="Expired">error</mat-icon>
        } @else if (isExpiringSoon(baa)) {
          <mat-icon class="status-icon expiring-soon" matTooltip="Expiring Soon">warning</mat-icon>
        } @else {
          <mat-icon class="status-icon active" matTooltip="Active">check_circle</mat-icon>
        }
      </td>
    </ng-container>

    <!-- Covered Entity Column -->
    <ng-container matColumnDef="coveredEntity">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Covered Entity</th>
      <td mat-cell *matCellDef="let baa" class="name-cell">
        <span class="entity-name">{{ extractEntityName(baa.coveredEntity) || '—' }}</span>
        @if (baa.baaId) {
          <span class="entity-id-badge">{{ baa.baaId }}</span>
        }
      </td>
    </ng-container>

    <!-- Business Associate Column -->
    <ng-container matColumnDef="businessAssociateName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Associate</th>
      <td mat-cell *matCellDef="let baa">{{ extractEntityName(baa.businessAssociateName) || '—' }}</td>
    </ng-container>

    <!-- Primary Owner Column -->
    <ng-container matColumnDef="primaryOwner">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Primary Owner</th>
      <td mat-cell *matCellDef="let baa">{{ extractOwnerName(baa.primaryOwner) || '—' }}</td>
    </ng-container>

    <!-- Expiration Date Column -->
    <ng-container matColumnDef="expirationDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</th>
      <td mat-cell *matCellDef="let baa"
          [class.overdue-text]="isExpired(baa)"
          [class.due-soon-text]="isExpiringSoon(baa)">
        {{ formatDate(baa.expirationDate) }}
      </td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
      <td mat-cell *matCellDef="let baa" class="description-cell">{{ baa.description || '' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        class="entity-row"
        (click)="onRowClicked(row)">
    </tr>

    <!-- No data row -->
    <tr class="mat-row no-data-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <div class="no-data-message">
          @if (isLoading) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            <p>Loading BAAs...</p>
          } @else {
            <mat-icon>folder_open</mat-icon>
            <p>No BAAs found</p>
          }
        </div>
      </td>
    </tr>
  </table>
</div>
